import { api } from '../../services/api'

const state = () => ({
  items: [],
  loading: false,
  error: null
})

const getters = {
  all: (s) => s.items
}

const mutations = {
  SET_ITEMS(state, items) { state.items = items },
  ADD_ITEM(state, item) { state.items.unshift(item) },
  UPDATE_ITEM(state, item) {
    const i = state.items.findIndex(x => String(x.id) === String(item.id))
    if (i !== -1) state.items.splice(i, 1, item)
  },
  REMOVE_ITEM(state, id) {
    state.items = state.items.filter(x => String(x.id) !== String(id))
  },
  SET_LOADING(state, v) { state.loading = v },
  SET_ERROR(state, e) { state.error = e }
}

const actions = {
  async list({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await api.get('gallery-section')
      commit('SET_ITEMS', Array.isArray(data) ? data : (data?.items || []))
      commit('SET_ERROR', null)
    } catch (e) {
      commit('SET_ERROR', e.message || 'Failed to load')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async create({ commit }, payload) {
    // payload is already a FormData built by the component — use it directly
    const { data } = await api.post('gallery-section', payload)
    commit('ADD_ITEM', data)
    return data
  },

  async update({ commit }, { id, payload }) {
    // payload is FormData (may contain a new image file)
    const { data } = await api.put(`admin/gallery-section/${id}`, payload)
    commit('UPDATE_ITEM', data)
    return data
  },

  async remove({ commit }, id) {
    await api.delete(`admin/gallery-section/${id}`)
    commit('REMOVE_ITEM', id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}